export const site = {
  name: 'Daily Car Care',
  city: 'Spijkenisse',
  address: 'Bohrweg 24, 3208 KR Spijkenisse',
  phone: '06 15 40 74 89',
  phoneHref: 'tel:+31615407489',
  whatsapp: 'https://wa.me/31615407489',
  email: 'info@dailycc.nl',
  instagram: 'https://www.instagram.com/dailycarcare',
  hours: [
    { day: 'Ma — Vr', time: '09:00 — 18:00' },
    { day: 'Zaterdag', time: '09:00 — 16:00' },
    { day: 'Zondag', time: 'Op afspraak' },
  ],
}

export const nav = [
  { label: 'Diensten', to: '/services' },
  { label: 'Ons werk', to: '/work' },
  { label: 'Studio', to: '/studio' },
  { label: 'Contact', to: '/contact' },
]

export const img = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/3f53722e-fd11-4952-93eb-957f171b3b4b.jpg',
  interior: 'https://cdn.magicpatterns.com/patterns/generated-images/3f0fd54a-d965-471e-a90f-3741c6c9ef9c.jpg',
  wash: 'https://cdn.magicpatterns.com/patterns/generated-images/85daf723-3e08-46a9-9918-28bd769cca84.jpg',
  correction: 'https://cdn.magicpatterns.com/patterns/generated-images/626fddd7-b7bb-439b-ae31-b706ac9d9a0b.jpg',
  wheel: 'https://cdn.magicpatterns.com/patterns/generated-images/5bcc2d75-8b1b-4773-a73d-7b64dd4f7be3.jpg',
  foam: 'https://cdn.magicpatterns.com/patterns/generated-images/093b0997-cf43-4071-8067-fb60279b0962.jpg',
  beading: 'https://cdn.magicpatterns.com/patterns/generated-images/540956ed-2b99-4ad1-a5d3-13c805ff20f8.jpg',
  studio: 'https://cdn.magicpatterns.com/patterns/generated-images/f730757c-3d1b-404b-916d-fd9585c6bea9.jpg',
  before: 'https://cdn.magicpatterns.com/patterns/generated-images/51dcf31f-154c-401b-8dce-a3ef0f6a62e5.jpg',
  after: 'https://cdn.magicpatterns.com/patterns/generated-images/cabc7bd5-03cf-46bf-9007-6c3dbef9c7c4.jpg',
}

export const ticker = [
  'Handwas volgens 2-emmer methode',
  'Stoom & extractie',
  'Lakcorrectie 80—95%',
  'Keramische coating',
  'Velgen intensief reinigen',
  'Uitsluitend op afspraak',
]
